import React, { useState } from 'react';
import CouponsList from './coupons-list';
import CouponForm from './coupon-form';
import { useAppSelector } from '../../data/store';
import { CouponBoxState } from '../../enums/coupon-box-state';

const Coupon = () => {

    const cartData = useAppSelector(store => store.root.cartData);
    const showCouponNavError = useAppSelector(store => store.coupons.showCouponNavError);

    const [isOpened, setIsOpened] = useState(false);

    /**
     * in case of closed coupon box (defined by Kentico settings) ---> open it
     */
    const openCouponBox = () => {
        setIsOpened(true);
    };

    return (
        <div className="mb-4">
            {
                !isOpened && cartData.couponBoxState === CouponBoxState.Closed && (
                    <button
                        type="button"
                        onClick={ openCouponBox }
                        data-qa="cart-add-coupon-link"
                        className="text-blue-200 underline">
                        Add Coupon Code
                    </button>
                )
            }

            { (isOpened || cartData.couponBoxState === CouponBoxState.Opened) && <CouponForm /> }

            {
                showCouponNavError &&
                <div className="error-box my-2" role="alert">
                    <p>Please submit your coupon code by clicking Apply, or clear the text box to continue.</p>
                </div>
            }

            <CouponsList />
        </div>
    )
};

export default Coupon;